import BaseLayout from './BaseLayout';
import EmbedLayout from './EmbedLayout';
import MainLayout from './MainLayout/MainLayout';
import PublicLayout from './PublicLayout';
export const DefaultLayout = BaseLayout;

export const Layout = {
  Main: MainLayout,
  Base: BaseLayout,
  Embed: EmbedLayout,
  Public: PublicLayout,
};

export default Layout;
